import type { SVGProps } from "react";

export default function HelpCircleIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="20"
      width="20"
      viewBox="0 -960 960 960"
      fill="currentColor"
      {...props}
    >
      <path d="M475 -240Q500 -240 518 -258Q536 -276 536 -301.1Q536 -326.3 518 -343.6Q500 -361 475 -361Q450 -361 432 -343.6Q414 -326.3 414 -301.1Q414 -276 432 -258Q450 -240 475 -240ZM428 -394H522Q522 -423 530 -443Q538 -463 568 -492Q591 -514 605.5 -539.1Q620 -564.1 620 -599.3Q620 -659 581 -690.5Q542 -722 486 -722Q425 -722 384.5 -687Q344 -652 328 -604L416 -571Q423 -591 438 -611Q453 -631 481 -631Q501 -631 512 -618.5Q523 -606 523 -591Q523 -576 512.5 -560Q502 -544 491 -535Q451 -498 439.5 -474.5Q428 -451 428 -394ZM480 -46Q389 -46 310 -80.1Q231 -114.2 172.6 -172.6Q114.2 -231 80.1 -310Q46 -389 46 -480Q46 -571 80.1 -650Q114.2 -729 172.6 -787.4Q231 -845.8 310 -879.9Q389 -914 480 -914Q571 -914 650 -879.9Q729 -845.8 787.4 -787.4Q845.8 -729 879.9 -650Q914 -571 914 -480Q914 -389 879.9 -310Q845.8 -231 787.4 -172.6Q729 -114.2 650 -80.1Q571 -46 480 -46ZM480 -172Q610 -172 699 -261Q788 -350 788 -480Q788 -610 699 -699Q610 -788 480 -788Q350 -788 261 -699Q172 -610 172 -480Q172 -350 261 -261Q350 -172 480 -172Z"/>
    </svg>
  )
}
